module.exports = __webpack_public_path__ + "static/satyr-7e7d9966d04ddb558a753ef26d022943.jpeg";